import { useData } from '../useData';
import { formatScreensaverData } from '../../formatters/screensaverFormatter';

export const useScreensaverData = station => {
  return useData({
    endpoint: 'screensavers',
    filters: { Station: station },
    formatter: formatScreensaverData,
  });
};
